export const BYTES = 'Bytes'
export const COMMENT = 'Comment'
export const IDENTIFIER = 'Identifier'
export const KEYWORD_ALLOW = 'KeywordAllow'
export const KEYWORD_FUNCTION = 'KeywordFunction'
export const KEYWORD_IF = 'KeywordIf'
export const KEYWORD_IN = 'KeywordIn'
export const KEYWORD_IS = 'KeywordIs'
export const KEYWORD_LET = 'KeywordLet'
export const KEYWORD_MATCH = 'KeywordMatch'
export const KEYWORD_RETURN = 'KeywordReturn'
export const KEYWORD_SERVICE = 'KeywordService'
export const NUMBER = 'Number'
export const OPERATOR_AMPERSAND = 'OperatorAmpersand'
export const OPERATOR_ASSIGNMENT = 'OperatorAssignment'
export const OPERATOR_AT_SIGN = 'OperatorAtSign'
export const OPERATOR_BACKWARD_SLASH = 'OperatorBackwardSlash'
export const OPERATOR_CLOSE_BRACKET = 'OperatorCloseBracket'
export const OPERATOR_CLOSE_CURLY_BRACE = 'OperatorCloseCurlyBrace'
export const OPERATOR_CLOSE_PARENTHESIS = 'OperatorCloseParenthesis'
export const OPERATOR_COLON = 'OperatorColon'
export const OPERATOR_COMMA = 'OperatorComma'
export const OPERATOR_DIVIDE = 'OperatorDivide'
export const OPERATOR_DOLLAR_SIGN = 'OperatorDollarSign'
export const OPERATOR_DOT = 'OperatorDot'
export const OPERATOR_EQUALITY = 'OperatorEquality'
export const OPERATOR_GREATER_THAN = 'OperatorGreaterThan'
export const OPERATOR_GREATER_THAN_EQUAL = 'OperatorGreaterThanEqual'
export const OPERATOR_INEQUALITY = 'OperatorInequality'
export const OPERATOR_INFINITY = 'OperatorInfinity'
export const OPERATOR_LESS_THAN = 'OperatorLessThan'
export const OPERATOR_LESS_THAN_EQUAL = 'OperatorLessThanEqual'
export const OPERATOR_LOGICAL_AND = 'OperatorLogicalAnd'
export const OPERATOR_LOGICAL_NOT = 'OperatorLogicalNot'
export const OPERATOR_LOGICAL_OR = 'OperatorLogicalOr'
export const OPERATOR_MODULUS = 'OperatorModulus'
export const OPERATOR_MULTIPLY = 'OperatorMultiply'
export const OPERATOR_OPEN_BRACKET = 'OperatorOpenBracket'
export const OPERATOR_OPEN_CURLY_BRACE = 'OperatorOpenCurlyBrace'
export const OPERATOR_OPEN_PARENTHESIS = 'OperatorOpenParenthesis'
export const OPERATOR_QUESTION_MARK = 'OperatorQuestionMark'
export const OPERATOR_SEMICOLON = 'OperatorSemicolon'
export const OPERATOR_TILDE = 'OperatorTilde'
export const OPERATOR_UNARY_MINUS = 'OperatorUnaryMinus'
export const OPERATOR_UNARY_PLUS = 'OperatorUnaryPlus'
export const STRING = 'String'
export const WHITESPACE = 'Whitespace'
